export const ActivateTrialModal: string = 'ActivateTrialModal';
